import { Controller } from "@hotwired/stimulus"
import hljs from 'highlight.js'

export default class extends Controller {
  static values = {
    url: String
  }

  static targets = ["refreshButton", "response"]

  connect() {
    console.log('API Highlight Controller connected')
    this.responseTarget.textContent = 'Loading...'
    this.loadData()
  }

  loadData() {
    this.fetchData(this.urlValue)
  }

  refresh() {
    this.fetchData(this.urlValue + '?refresh=true')
  }

  fetchData(url) {
    this.responseTarget.textContent = 'Loading...'

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`)
        }
        return response.json()
      })
      .then(data => {
        const formattedJson = JSON.stringify(data, null, 2)
        this.responseTarget.innerHTML = `<pre><code class="language-json">${formattedJson}</code></pre>`
        hljs.highlightElement(this.responseTarget.querySelector('code'))
        console.log(data)
      })
      .catch(error => {
        console.error('API fetch error:', error)
        this.responseTarget.innerHTML = `<div class="alert alert-danger">
          <strong>Error loading data:</strong> ${error.message}
          <br><small>Please try refreshing the page or contact support if the problem persists.</small>
        </div>`
      })
  }
}

